













import Vue from 'vue';
import {router} from '@/main';
import {Actions} from '@/store';
import {ConfirmEmail} from '@/models/account';

export default Vue.extend({
  name: 'ConfirmEmailView',
  data() {
    return {
      loader: {
        isLoading: true,
      },
      params: {
        user: '',
        token: '',
      },
    };
  },
  async created() {
    if (!this.$route.params.user?.trim() || !this.$route.params.token?.trim()) {
      router.push({name: 'error-page', params: {errorMessageKey: 'not-found'}});

      return;
    }

    this.params.user = this.$route.params.user;
    this.params.token = this.$route.params.token;

    const model: ConfirmEmail =  {
      token: this.params.token,
      user: this.params.user,
    };

    await this.$store
      .dispatch(Actions.account.confirmNewEmail, model)
      .finally(() => {
        this.loader.isLoading = false;
      });
  },
});
